import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuperLink = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("mask", {
			id: "s-cutout",
			children: [/* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white"
			}), /* @__PURE__ */ _jsx("text", {
				x: 11.8,
				y: 10.2,
				fontFamily: "Arial, sans-serif",
				fontSize: 7.5,
				fontWeight: "bold",
				textAnchor: "middle",
				fill: "black",
				children: "S"
			})]
		}) }),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.3377 6.74338C5.27257 7.38036 5.3041 8.02353 5.43123 8.65108V8.65231C3.8657 8.144 2.61523 8.18954 2.61523 8.18954V6.35569C3.53283 6.3997 4.44429 6.5295 5.3377 6.74338ZM2.61523 2.448C4.06467 2.51566 5.50225 2.74267 6.902 3.12492C6.45749 3.61867 6.09288 4.17887 5.82139 4.78523C3.97893 4.22277 2.61523 4.176 2.61523 4.176V2.448ZM2.61523 16.8172V13.8548C2.61523 13.8548 5.63308 13.9631 5.63308 16.8172H2.61523ZM14.598 13.0068C15.2172 12.6791 15.7781 12.2516 16.2583 11.7415C17.2909 14.5095 17.2983 16.8172 17.2983 16.8172H15.4595C15.2971 15.392 14.998 14.1292 14.598 13.0068ZM2.61523 11.8966V10.064C9.49646 10.4308 9.51493 16.8172 9.51493 16.8172H7.69339C6.99431 11.8302 2.61523 11.8966 2.61523 11.8966ZM10.7174 13.6468C11.014 13.6898 11.318 13.7132 11.6282 13.7132C11.9945 13.7126 12.3602 13.6805 12.7211 13.6172C13.3008 15.4043 13.3057 16.8172 13.3057 16.8172H11.4842C11.3451 15.5938 11.0743 14.5489 10.7174 13.6468Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.44 11.2026C14.429 12.2136 13.0579 12.7815 11.6282 12.7815C10.1984 12.7815 8.82727 12.2136 7.81631 11.2026C6.80534 10.1917 6.23739 8.82049 6.23739 7.39077C6.23739 5.96105 6.80534 4.58988 7.81631 3.57892C8.82727 2.56795 10.1984 2 11.6282 2C13.0579 2 14.429 2.56795 15.44 3.57892C16.451 4.58988 17.0189 5.96105 17.0189 7.39077C17.0189 8.82049 16.451 10.1917 15.44 11.2026Z",
			fill: "currentColor",
			mask: "url(#s-cutout)"
		})
	]
});
export default SvgSuperLink;
